import { constants, typographyStyles } from "@newsela/angelou";

const { heading4Obj, heading5Obj } = typographyStyles;

const colors = constants.colors;
const extraLightGrey = colors.ui.neutral[25];
const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[700];
const neutral600 = colors.ui.neutral[600];

export const assignmentHeaderCss = {
  ...heading4Obj,
  color: neutral600,
  fontWeight: "700",
  lineHeight: 1.5,
  margin: "0 0 5px 0",
};

export const assignmentAnchorCss = {
  backgroundColor: extraLightGrey,
  borderRadius: "8px",
  borderStyle: "none",
  color: grey,
  display: "inline-block",
  marginBottom: "16px",
  padding: "8px 0px",
  width: "100%",

  "> div": {
    display: "flex",
  },

  svg: {
    color: greyDark,
    marginRight: "16px",
    width: "100%",
  },
};

export const bylineCss = {
  color: "black",
  margin: "4px 0 8px 0",
};

export const containerCss = {
  display: "flex",
  flexDirection: "column",
  margin: "16px",
  width: "90%",
};

export const headingCss = {
  ...heading5Obj,
  color: neutral600,
  fontWeight: "700",
  lineHeight: 1.5,
};

export const assigneeCss = {
  color: "black",
  margin: "10px 0 15px 0",
};
